import { render, staticRenderFns } from "./LatestBidsModal.vue?vue&type=template&id=0ac230c8&scoped=true"
import script from "./LatestBidsModal.vue?vue&type=script&lang=js"
export * from "./LatestBidsModal.vue?vue&type=script&lang=js"
import style0 from "./LatestBidsModal.vue?vue&type=style&index=0&id=0ac230c8&prod&scoped=true&lang=scss"
import style1 from "./LatestBidsModal.vue?vue&type=style&index=1&id=0ac230c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac230c8",
  null
  
)

export default component.exports